import React from 'react';
import PropTypes from 'prop-types';
import Anchor from 'common-ui-components/dist/components/Atoms/Anchor';
import { ReactSVG } from 'react-svg';
import { getLabelWithComponent } from '../../../utils/utils';
import { SET_SIGN_IN_REDIRECT_KEY } from '../../../global/constants';

const ShoppingCartPersistenceMessage = ({ className, labels, config }) => {
  const result = getLabelWithComponent(labels.cartPersistenceMessage, [
    <Anchor
      key="sigin-anchor"
      elementLocator="link-cart-persistence-sign-in"
      to={config.signInUrl}
      {...{
        onClick: () => {
          window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, window.location.href);
        },
      }}
    >
      <ReactSVG wrapper="span" className="icon" src={config.userIcon} />
      {labels.signIn}
    </Anchor>,
    <Anchor
      key="create-anchor"
      elementLocator="link-cart-persistence-create-account"
      to={config.createAccountUrl}
      {...{
        onClick: () => {
          window.sessionStorage.setItem(SET_SIGN_IN_REDIRECT_KEY, window.location.href);
        },
      }}
    >
      {labels.createAccount}
    </Anchor>,
  ]);

  return (
    <div className={className} data-locator="shopping-cart-persistence-message">
      {result.map(item => {
        if (typeof item === 'string') {
          return <span key={item}>{item}</span>;
        }
        return item;
      })}
    </div>
  );
};

ShoppingCartPersistenceMessage.propTypes = {
  className: PropTypes.string,
  labels: PropTypes.objectOf(PropTypes.string),
  config: PropTypes.objectOf(PropTypes.string),
};

ShoppingCartPersistenceMessage.defaultProps = {
  className: '',
  labels: {},
  config: {},
};

export default ShoppingCartPersistenceMessage;
